import React from 'react';

//handle lifeline dashboard option click
const handleLifelineDbClick = () => {
  window.open('/lifeline', '_blank');
};

// lifeline Dashboard menu option
const LifelineDashboardOption = () => {
  return (
    <div
      className={`tw-py-1 tw-w-full tw-border-solid tw-border-grey-200 tw-border-[1px] tw-border-x-0 tw-border-t-0 tw-pb-3 tw-font-medium tw-text-grey-700 tw-cursor-pointer`}
      onClick={handleLifelineDbClick}
      role='button'
      tabIndex={0}
    >
      Lifeline Dashboard
    </div>
  );
};

export default LifelineDashboardOption;
